import { AxiosRequest } from "_services/api";

// Abre o processo em nova guia (mesmo padrão das demais telas: resolve o param
// criptografado e abre o Processo.php do app legado).
export function useAbrirProcesso() {
  const api = AxiosRequest.makeApi(process.env.REACT_APP_API_DESPACHANTE_BASE_URL);

  const redirecionarProcesso = async (idProcesso: number) => {
    try {
      const { data } = await api.get(`/processos/param/${idProcesso}`);
      window.open(
        `${process.env.REACT_APP_DESPACHANTE_BASE_URL}/pages/processo/Processo.php?param=${data}`,
        "_blank",
      );
    } catch {
      // silencioso: falha ao abrir o processo não deve quebrar a tela
    }
  };

  return { redirecionarProcesso };
}
